import React, { PureComponent } from 'react'
import ContextButton from './contextButton'
import { MAIN_SHARE_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

class DesktopShareButton extends PureComponent {
    render() {
        const { style, offsetX, offsetY, onClick, children, className } = this.props

        return (
            <ContextButton
                tabIndex={MAIN_SHARE_BUTTON_INDEX}
                id="share_desktop"
                className={className || ''}
                offsetX={offsetX}
                offsetY={offsetY}
                onClick={onClick}
                icon="socialShare"
                style={style}
                alt="share"
                puresvg={true}
            >
                {children}
            </ContextButton>
        )
    }
}

export default DesktopShareButton
